//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export const enum PostType {
  Post = 'post',
  Gallery = 'gallery',
  Story = 'story',
}
